<template>
<section id="ModalEditAccountInfo">
    <fieldset>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>{{$t('Full Name')}}</label>
                    <input type="text" :placeholder="$t('Full Name')" class="form-control">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Company Name')}}</label>
                    <input type="text" :placeholder="$t('Company Name')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Tax ID')}}</label>
                    <input type="text" :placeholder="$t('Tax ID')" class="form-control">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Address')}}</label>
                    <input type="text" :placeholder="$t('Address')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Sub District')}}</label>
                    <input type="text" :placeholder="$t('Sub District')" class="form-control">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('District')}}</label>
                    <input type="text" :placeholder="$t('District')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Province')}}</label>
                    <input type="text" :placeholder="$t('Province')" class="form-control">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('ZIP/Postal Code')}}</label>
                    <input type="text" :placeholder="$t('ZIP/Postal Code')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Country')}}</label>
                    <!-- <select class="form-control">
                            <option value="th" selected>Thailand</option>
                            <option value="en">English</option>
                            <option value="cn">China</option>
                        </select> -->
                    <Select2 v-model="country" :options="countryOptions" :settings="countryOptionsSettings" />
                </div>
            </div>
        </div>
        <!-- <div class="form-group">
            <div class="form-check">
                <label class="form-check-label">
                    <input type="checkbox" class="form-check-input"> <span class="text-muted"> Billing address same as address info</span>

                </label>
            </div> 
        </div>  -->
        <div class="form-group">
            <g-s-checkbox  ref="CheckboxTest" labelText="Billing address same as address info">
                <input type="checkbox" class="custom-control-input" value="true" /> 
            </g-s-checkbox> 
        </div> 

        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Billing Address')}}</label>
                    <input type="text" :placeholder="$t('Billing Address')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <div class="form-group">
                        <label>{{$t('Sub District')}}</label>
                        <input type="text" :placeholder="$t('Sub District')" class="form-control">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('District')}}</label>
                    <input type="text" :placeholder="$t('District')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <div class="form-group">
                        <label>{{$t('Province')}}</label>
                        <input type="text" :placeholder="$t('Province')" class="form-control">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('ZIP/Postal Code')}}</label>
                    <input type="text" :placeholder="$t('ZIP/Postal Code')" class="form-control">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{$t('Country')}}</label>
                    <!-- <select class="form-control">
                            <option value="th" selected>Thailand</option>
                            <option value="en">English</option>
                            <option value="cn">China</option>
                        </select> -->
                    <Select2 v-model="country" :options="countryOptions" :settings="countryOptionsSettings" />
                </div>
            </div>
        </div>
        <div class="form-group mt-3">
            <div class="text-center">
                <button type="submit" class="btn btn-primary mr-2"><i class="fas fa-save mr-2"></i>{{$t('Save')}}</button>
                <button type="submit" class="btn btn-light" data-dismiss="modal">{{$t('Cancel')}}</button>
            </div>
        </div>
    </fieldset>
</section>
</template>

<script>
import Select2 from "v-select2-component";
import GSCheckbox from "@/components/GSCheckbox.vue";
export default {
    components: {
        Select2,
        GSCheckbox
    },
    data() {

        return {

            country: "Thai",
            countryOptions: ['Thai', 'English'],
            countryOptionsSettings: {
                minimumResultsForSearch: Infinity,
                placeholder: " "
            },
        };
    },
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/profile/ModalEditAccountInfo.vue